webpackJsonp([10],{

/***/ 1000:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(94)(false);
// imports
exports.i(__webpack_require__(1001), "");
exports.i(__webpack_require__(1002), "");
exports.i(__webpack_require__(1003), "");
exports.i(__webpack_require__(1004), "");
exports.i(__webpack_require__(1005), "");
exports.i(__webpack_require__(1006), "");

// module
exports.push([module.i, ".fontMini{font-size:10px;font-size:1rem}.btn,.fontBody,.masterBoxViewValue p,.module.buttonModalSelectMultiData .boxDatas p,.module.inputForm .boxViewValue p,.module.inputForm .labelInput .required,.module.inputForm .labelInput .subject,.module.layoutWithSidebar .menuSidebar,.module.layoutWithSidebar .sidebarBox .actionBox .userBox p,.module.layoutWithSidebar .sidebarBox .headerBox .text p,.module.popupUser .userContent .contentDetail .detailUser .email,.scrollListFormBox p,.scrollListViewBox p,.ui.button,.viewBox p,p{font-size:14px;font-size:1.4rem}.fontBodyImportant,.text,.ui.checkbox,.ui.dropdown,.ui.form,.ui.input{font-size:14px!important;font-size:1.4rem!important}.fontHeader,.module.alertModal .headerBox .text p,.module.customTable .boxNoData p,.module.header .menu-item.text,.module.header .menuMobile,.module.inputForm .headerBoxHeaderTap,.module.itemSettingBox .boxTextHeaderSetting p,.module.mymodal .headerBox .text p,.module.popupUser .userContent .contentDetail .detailUser .name{font-size:16px!important;font-size:1.6rem!important}.boxHeaderPage p,.fontHeaderBody,.fontHeaderPage,.module.loginForm .text-box p{font-size:28px;font-size:2.8rem}.fontSettingValueView,.module.itemSettingBox .boxTextValueSetting p{font-size:20px;font-size:2rem}.module.itemSettingBox .boxTextHeaderSetting p,.module.itemSettingBox .boxTextValueSetting p,.textOverflow{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.btn{font-weight:700!important;min-width:100px;min-height:40px!important}.btn.submit{background-color:#0b56a4!important;color:#fff!important;border:1px solid #0b56a4!important}.btn.submit.active,.btn.submit:hover{background-color:#fff!important;color:#0b56a4!important;border:1px solid #0b56a4!important}.btn.cancel{background-color:#c1c1c1!important;color:#fff!important;border:1px solid #c1c1c1!important}.btn.cancel.active,.btn.cancel:hover{background-color:#fff!important;color:#c1c1c1!important;border:1px solid #c1c1c1!important}.btn.delete{background-color:#f15e5e!important;color:#fff!important;border:1px solid #f15e5e!important}.btn.delete.active,.btn.delete:hover{background-color:#fff!important;color:#f15e5e!important;border:1px solid #f15e5e!important}.btn.add{background-color:#43b05c!important;color:#fff!important;border:1px solid #43b05c!important}.btn.add.active,.btn.add:hover{background-color:#fff!important;color:#43b05c!important;border:1px solid #43b05c!important}.btn.reset{background-color:#f39200!important;color:#fff!important;border:1px solid #f39200!important}.btn.reset.active,.btn.reset:hover{background-color:#fff!important;color:#f39200!important;border:1px solid #f39200!important}.iconView{background-color:#6435c9!important;color:#fff!important}.iconView,.iconView:hover{border:1px solid #6435c9!important}.iconView:hover{background-color:#fff!important;color:#6435c9!important}.iconUpdate{background-color:#0b56a4!important;color:#fff!important}.iconUpdate,.iconUpdate:hover{border:1px solid #0b56a4!important}.iconUpdate:hover{background-color:#fff!important;color:#0b56a4!important}.iconReset{background-color:#f39200!important;color:#fff!important}.iconReset,.iconReset:hover{border:1px solid #f39200!important}.iconReset:hover{background-color:#fff!important;color:#f39200!important}.iconDelete{background-color:#f15e5e!important;color:#fff!important}.iconDelete,.iconDelete:hover{border:1px solid #f15e5e!important}.iconDelete:hover{background-color:#fff!important;color:#f15e5e!important}.iconAdd{background-color:#43b05c!important;color:#fff!important}.iconAdd,.iconAdd:hover{border:1px solid #43b05c!important}.iconAdd:hover{background-color:#fff!important;color:#43b05c!important}.ui.checkbox,.ui.dropdown,.ui.form,.ui.form .field>label,.ui.form textarea,.ui.input,.ui.input input,.ui[class*=\"left icon\"].input>input,a,body,button,div,h1,h2,h3,h4,h5,h6,p,span{font-family:THSarabunNew,sans-serif!important}body{background-color:#f5f5f5}p{margin:0}.gridNogMargin,.gridNoPaddingMargin,.gridNoPaddingMargin>.column,.gridNoPaddingMargin>.row,.gridNoPaddingMargin>.row>.column{padding:0!important;margin:0!important}.gridColumnNoPaddingTB{padding-top:0!important;padding-bottom:0!important}.contentHeightMax{height:100%}.scrollListFormBox,.scrollListViewBox{height:140px;overflow-y:auto;overflow-x:hidden}.scrollListViewBox,.viewBox{background-color:#e9e9e9}.scrollListFormBox{background-color:#fff}.masterBoxViewValue,.module.buttonModalSelectMultiData .boxDatas,.scrollListFormBox,.scrollListViewBox,.viewBox{padding:1rem}.masterBoxViewValue p,.module.buttonModalSelectMultiData .boxDatas p,.scrollListFormBox p,.scrollListViewBox p,.viewBox p{margin:0!important}.boxDatePicker{width:200px}.boxDatePicker.fluid{width:100%}.listSelectAll{padding-bottom:.42857143em;padding-top:.42857143em;background-color:#fff}.iWAAXb{padding:0 25px 0 10px!important}.ui.dimmer{z-index:2000!important}.iconMenuRowTable{cursor:pointer}.boxHeaderPage p{font-weight:700}.MuiDialog-root{z-index:2300!important}.module.alertModal,.module.buttonModalSelectMultiData,.module.itemButtonWithText .boxTex,.module.mymodal,.noselect{-webkit-touch-callout:none!important;-webkit-user-select:none!important;-khtml-user-select:none!important;-moz-user-select:none!important;-ms-user-select:none!important;user-select:none!important}.subject{font-weight:700}.imageForm{height:200px}.imageForm img{margin:10px 30px;height:100%;width:auto}.boxImageUserList{height:70px;width:70px;margin:.5rem;display:flex;align-items:center;justify-content:center}.boxImageUserList>img{max-height:100%;max-width:100%;width:auto}.boxArrayDayList{max-height:80px;width:300px;text-align:center;overflow-y:auto;overflow-x:hidden}.my-page{width:100%;height:calc(100vh - 40px);display:flex;flex-direction:column}.my-page>.page-header{width:100%;padding:3rem 0 1rem;margin-top:-2rem;flex:0}.my-page>.page-body{width:100%;flex:1;overflow:hidden}.my-page>.page-body>.body{height:100%}.my-page>.page-body>.body,.my-page>.page-body>.dataTable{width:100%;overflow-x:hidden;overflow-y:auto;padding:2rem 2rem 2rem 0}.my-page>.page-body>.dataTable{height:90%}.my-page>.page-body>.dataAction{height:10%;width:100%;overflow-x:hidden;overflow-y:auto;padding:2rem 2rem 2rem 0}.my-page>.page-footer{width:100%;height:70px;padding:1rem 0;margin-bottom:-2rem;text-align:center}.module.loadableController,.module.loadableRoute{height:100vh;display:flex;justify-content:center;align-items:center}.module.switchLanguage{display:flex}.module.switchLanguage .language-item{padding:5px 10px}.module.switchLanguage .language-item.select{background-color:#ccc}.module.errorBoundary .grid-header{padding-top:50px}.module.header{margin:0;box-shadow:0 4px 12px 0 rgba(0,0,0,.05)!important;background-color:#000!important;position:absolute;width:100%;margin:0!important;top:0;z-index:2000}.module.header .logo-box{width:100%;height:100%;display:flex;justify-content:center;align-items:center}.module.header .logo-box img{display:inline-block;max-width:100%;max-height:100%}.module.header .menu-item.logoUser{padding-top:0;padding-bottom:0}.module.header .menu-item.logo{padding:0;width:150px;height:50px}.module.header .menu-item.text p{color:#fff!important;font-weight:700}.module.header .menuBoxDesktop{width:100%}.module.header .menuBoxDesktop .menuRight{width:100%;height:100%;justify-content:flex-end}.module.header .menuBoxMobile{width:100%;display:flex}.module.header .menuMobile{padding:0!important}.module.header .menuMobile>i{display:none!important}.module.header .imageMenuMobile>i{margin:0!important}.module.header .itemMenuDropdown,.module.header .subMenuDropdown{width:180px}.module.header .userImage{width:40px;height:40px;border-radius:50%;overflow:hidden;cursor:pointer}.module.header .userImage img{width:100%;height:100%}.module.alertModal .header-general{background-color:#fff}.module.alertModal .header-error{background-color:#e85e6c}.module.alertModal .header-warning{background-color:#f1b65e}.module.alertModal .headerBox{display:flex;flex:1}.module.alertModal .headerBox .icon{flex:0 0 auto}.module.alertModal .headerBox .text{flex:1}.module.alertModal .headerBox .text p{font-weight:700}.module.alertModal .headerBox .text.general{color:#000}.module.alertModal .headerBox .text.error,.module.alertModal .headerBox .text.warning{color:#fff}.module.alertModal .headerBox .action{flex:0 0 auto;display:flex;align-items:center}.module.alertModal .headerBox .action .iconClose{cursor:pointer}.module.alertModal .headerBox .action .iconClose.general{color:#f15e5e}.module.alertModal .headerBox .action .iconClose.error,.module.alertModal .headerBox .action .iconClose.warning{color:#fff}.module.alertModal .headerBox .action .iconClose.error,.module.alertModal .headerBox .action .iconClose.general,.module.alertModal .headerBox .action .iconClose.warning{opacity:.45}.module.alertModal .headerBox .action .iconClose.error:hover,.module.alertModal .headerBox .action .iconClose.general:hover,.module.alertModal .headerBox .action .iconClose.warning:hover{opacity:1}.module.alertModal .contentBox{min-height:100px}.module.alertModal .actionBox button:last-child{margin:0}.module.mymodal .header-info{background-color:#2185d0;color:#fff}.module.mymodal .header-success{background-color:#21ba45;color:#fff}.module.mymodal .header-warning{background-color:#f1b65e;color:#fff}.module.mymodal .header-error{background-color:#e85e6c;color:#fff}.module.mymodal .headerBox{display:flex;flex:1}.module.mymodal .headerBox .icon{flex:0 0 auto}.module.mymodal .headerBox .text{flex:1}.module.mymodal .headerBox .text p{font-weight:700}.module.mymodal .headerBox .text.general{color:#000}.module.mymodal .headerBox .text.error,.module.mymodal .headerBox .text.warning{color:#fff}.module.mymodal .headerBox .action{flex:0 0 auto;display:flex;align-items:center}.module.mymodal .headerBox .action .iconClose{cursor:pointer}.module.mymodal .headerBox .action .iconClose.general{color:#f15e5e}.module.mymodal .headerBox .action .iconClose.error,.module.mymodal .headerBox .action .iconClose.warning{color:#fff}.module.mymodal .headerBox .action .iconClose.error,.module.mymodal .headerBox .action .iconClose.general,.module.mymodal .headerBox .action .iconClose.warning{opacity:.45}.module.mymodal .headerBox .action .iconClose.error:hover,.module.mymodal .headerBox .action .iconClose.general:hover,.module.mymodal .headerBox .action .iconClose.warning:hover{opacity:1}.module.mymodal .contentBox{min-height:100px}.module.mymodal .actionBox button:last-child{margin:0}.module.inputForm{width:100%}.module.inputForm .formField{margin:0!important}.module.inputForm .formField.pickerType{position:relative}.module.inputForm .boxViewValue{background-color:#e9e9e9;padding:1rem}.module.inputForm .boxViewValue p,.module.inputForm .labelInput p{margin:0!important}.module.inputForm .labelInput .required,.module.inputForm .labelInput .subject{font-weight:700;display:inline-block}.module.inputForm .labelInput .required{color:red}.module.inputForm .boxDatePicker>.MuiFormControl-root{display:none!important}.module.inputForm .textValid{color:red}.module.inputForm .hidePicker{display:none}.module.inputForm .inputFile,.module.inputForm .inputFile input,.module.inputForm .inputPicker,.module.inputForm .inputPicker input{opacity:unset!important}.module.inputForm .btnPicker,.module.inputForm .btnUploadFile{position:absolute;top:50%;right:0;transform:translateY(-50%)}.module.inputForm .btnPicker button,.module.inputForm .btnUploadFile button{transform:translateX(-30%)}.module.inputForm .boxColumSubjectTop{padding-top:1rem!important}.module.inputForm .headerBoxHeaderTap{font-weight:700}.module.inputForm .editorInputHtml{height:275px!important;border:1px solid #f1f1f1!important;padding:5px!important;border-radius:2px!important;background-color:#fff}.module.inputForm .boxInputUploadFile{display:flex}.module.inputForm .boxInputUploadFile .inputBox{flex:1}.module.inputForm .boxInputUploadFile .actionBox{flex:0 0 auto}.module.inputForm .boxInputUploadFile .actionBox button{height:100%;margin-right:0;margin-left:.5rem}.module.popupUser .userContent{display:flex;widows:200px}.module.popupUser .userContent .contentImage{flex:0 0 auto;width:70px;height:70px;border-radius:50%;overflow:hidden}.module.popupUser .userContent .contentImage img{width:100%;height:100%}.module.popupUser .userContent .contentDetail{padding-left:1rem;flex:1}.module.popupUser .userContent .contentDetail .detailUser .name{font-weight:700}.module.popupUser .userAction{border-top:1px solid #ccc;display:flex;justify-content:flex-end;margin-top:1rem;padding-top:1rem}.module.popupUser .userAction button{padding-top:.5rem;padding-bottom:.5rem}.holiday{background:#f1f1f1}.speciaoHliday{background:#e85e6c}.fc-time-area .fc-rows td>div{height:100px!important}.fc-highlightSelect{background-color:#4183c4;height:99px!important;margin-top:1px!important;margin-left:1px!important}.fc-eventCustom{background-color:red;border:1px solid #fff}.fc-holiday{background-color:#ccc}.module.customTable .boxNoData{padding:3rem 0}.module.customTable .boxNoData p{font-weight:700}.module.loadingInline{height:100%;display:flex;align-items:center}.module.itemButtonWithText{display:flex;flex:1}.module.itemButtonWithText .boxButton{flex:0 0 auto}.module.itemButtonWithText .boxTex{flex:1;display:flex;align-items:center}.module.itemButtonWithText .boxTex.left{margin-left:.5rem}.module.itemButtonWithText .boxTex.right{margin-right:.5rem}.module.buttonModalSelectMultiData .boxDatas{height:140px;overflow-y:auto;overflow-x:hidden}.module.buttonModalSelectMultiData .listItemSticker{background-color:#fff;padding-bottom:.42857143em;padding-top:.42857143em}.module.layoutWithSidebar .sidebarBox{position:fixed;display:flex;flex-direction:column;top:0;bottom:0;left:0;width:250px;background-color:#363434;overflow-x:hidden;flex:1}.module.layoutWithSidebar .sidebarBox .headerBox{flex:0 0 auto;padding:10px;display:flex;justify-content:center;align-items:center;flex-direction:column}.module.layoutWithSidebar .sidebarBox .headerBox .imageBox{max-width:230px;max-height:60px}.module.layoutWithSidebar .sidebarBox .headerBox .imageBox img{width:100%;display:block}.module.layoutWithSidebar .sidebarBox .headerBox .text p{color:#3e90e5;font-weight:700}.module.layoutWithSidebar .sidebarBox .actionBox{border-top:1px solid #3e90e5}.module.layoutWithSidebar .sidebarBox .actionBox .userBox p{color:#3e90e5;font-weight:700}.module.layoutWithSidebar .sidebarBox .actionBox .btnBox{margin-top:10px}.module.layoutWithSidebar .sidebarBox .actionBox .btnBox button{padding-top:5px;padding-bottom:5px;width:100%}.module.layoutWithSidebar .sidebarBox .headerBox{border-bottom:1px solid #3e90e5;height:120px}.module.layoutWithSidebar .sidebarBox .actionBox,.module.layoutWithSidebar .sidebarBox .headerBox{flex:0 0 auto;padding:10px}.module.layoutWithSidebar .sidebarBox .menuBox{flex:1;overflow-y:auto}.module.layoutWithSidebar .bodyBox{margin-left:250px;min-width:550px;padding:2rem}.module.layoutWithSidebar .menuSidebar{width:100%;margin:0!important;min-height:unset;border:none;border-radius:unset}.module.layoutWithSidebar .menuSidebar .item{margin:0!important;color:#3e90e5;font-weight:700;background-color:#363434;border-radius:unset!important}.module.layoutWithSidebar .menuSidebar .item:hover{border-radius:unset!important;color:#fff!important;background-color:#252323}.module.layoutWithSidebar .menuSidebar .active.item{margin:0!important;font-weight:700;cursor:unset!important}.module.layoutWithSidebar .menuSidebar .active.item,.module.layoutWithSidebar .menuSidebar .active.item:hover{color:#fff!important;background-color:#3e90e5;border-radius:unset!important}.module.layoutWithSidebar #sidebarScroll::-webkit-scrollbar-track{-webkit-box-shadow:inset 0 0 6px rgba(0,0,0,.3);background-color:#363434}.module.layoutWithSidebar #sidebarScroll::-webkit-scrollbar{width:10px;background-color:#363434}.module.layoutWithSidebar #sidebarScroll::-webkit-scrollbar-thumb{border-radius:0;background-color:#363434;border:2px solid #3e90e5}.module.layoutBlank{height:100vh;height:calc(var(--vh, 1vh) * 100);overflow-x:hidden;overflow-y:auto;display:flex;justify-content:center;align-items:center}.module.login{width:100%}.module.login .posotion-switchLanguage{position:absolute;right:5px;top:5px}.module.login .forgotPassword{cursor:pointer;color:#0b56a4}.module.loginForm .image-box{display:flex;justify-content:center;align-items:center}.module.loginForm .image-box .image{max-width:100%}.module.loginForm .image-box .image img{width:100%;display:block}.module.loginForm .text-box{text-align:left}.module.loginForm .text-box p{margin:0;font-weight:700}.module.itemSettingBox{width:100%}.module.itemSettingBox .boxTextValueSetting{height:100px;display:flex;justify-content:center;align-items:center}.module.itemSettingBox .boxTextValueSetting p{font-weight:700}.module.itemSettingBox .boxTextValueSetting img{width:100%;max-height:100%;display:block}.module.itemSettingBox .boxTextValueSetting .btnAction{position:absolute;right:0;top:0}.module.itemSettingBox .boxTextHeaderSetting{display:flex;justify-content:center;align-items:center}.module.itemSettingBox .boxTextHeaderSetting p{font-weight:700}.module.itemMailContentBox{width:100%}.module.itemMailContentBox .boxEnabled{display:flex}.module.itemMailContentBox .boxEnabled p{font-weight:700;margin-right:1rem}.module.itemMailContentBox .boxMailContent .boxContent .subject,.module.itemMailContentBox .boxMailContent .boxSubject .subject{font-weight:700;margin:0}.module.itemMailContentBox .boxMailContent .boxContent .detail,.module.itemMailContentBox .boxMailContent .boxSubject .detail{margin-left:1rem}", ""]);

// exports


/***/ }),

/***/ 1009:
/***/ (function(module, exports) {

module.exports = {"add":"Add","areYouSure":"Are you sure ?","back":"Back","cancel":"Cancel","close":"Close","code":"Code","create":"Create","delete":"Delete","deleteMessage":"Confirm to delete this item ?","deleteSuccess":"Delete success","description":"Description","edit":"Edit","login":"Login","logout":"Logout","name":"Name","noData":"No Data","ok":"OK","remember":"Remember","select":"Select","share":"Share","submit":"Submit","success":"Success","systemMessage":"System Message","password":"Password","view":"View","update":"Update","userName":"Username","userRole":"Role","welcome":"Welcome "}

/***/ }),

/***/ 1010:
/***/ (function(module, exports) {

module.exports = {"title":"Display","ipAddress":"IP Address","code":"Code","macAddress":"MAC Address","mac":"MAC Address","license":"License","room":"Room","status":"Status","model":"Model","turnOn":"Turn On","turnOff":"Turn Off","create":"Create Display","update":"Update Display","view":"View Display","turnonSuccess":"Turn on display success","turnoffSuccess":"Turn off display success","lock":"Lock","unlock":"Unlock","lockSuccess":"Lock display success","unlockSuccess":"Unlock display success"}

/***/ }),

/***/ 1011:
/***/ (function(module, exports) {

module.exports = {"title":"Control Display Schedule"}

/***/ }),

/***/ 1012:
/***/ (function(module, exports) {

module.exports = {"require":"Require"}

/***/ }),

/***/ 1013:
/***/ (function(module, exports) {

module.exports = {"add":"เพิ่ม","areYouSure":"ยืนยัน ที่จะดำเนินการ ?","back":"กลับ","cancel":"ยกเลิก","close":"ปิด","code":"รหัส","create":"เพิ่ม","delete":"ลบ","deleteMessage":"ยืนยันที่จะลบรายการนี้ ?","deleteSuccess":"ลบรายการ สำเร็จ","description":"รายละเอียด","edit":"แก้ไข","login":"ลงชื่อเข้าใช้งาน","logout":"ออกจากระบบ","name":"ชื่อ","noData":"ไม่มีข้อมูล","ok":"ตกลง","remember":"จำไว้ในระบบ","select":"เลือก","share":"แชร์","submit":"ยืนยัน","success":"สำเร็จ","systemMessage":"System Message","password":"รหัสผ่าน","view":"ดู","update":"แก้ไข","userName":"ชื่อในระบบ","userRole":"สิทธิ","welcome":"สวัสดี คุณ "}

/***/ }),

/***/ 1014:
/***/ (function(module, exports) {

module.exports = {"title":"หน้าจอ","ipAddress":"IP Address","code":"รหัส","macAddress":"MAC Address","mac":"MAC Address","license":"License","room":"ห้อง","status":"สถานะ","model":"โมเดล","turnOn":"เปิด","turnOff":"ปิด","create":"เพิ่ม หน้าจอ","update":"แก้ไข หน้าจอ","view":"รายละเอียด หน้าจอ","turnonSuccess":"เปิด หน้าจอสำเร็จ","turnoffSuccess":"ปิด หน้าจอสำเร็จ","lock":"Lock","unlock":"Unlock","lockSuccess":"Lock หน้าจอสำเร็จ","unlockSuccess":"Unlock หน้าจอสำเร็จ"}

/***/ }),

/***/ 1015:
/***/ (function(module, exports) {

module.exports = {"title":"จัดการ Display Schedule"}

/***/ }),

/***/ 1016:
/***/ (function(module, exports) {

module.exports = {"require":"กรุณา ระบุ"}

/***/ }),

/***/ 142:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return REQUEST_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SET_ERROR; });
/* unused harmony export LOGOUT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CORE_AUTH_VERIFY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CORE_AUTH_VERIFY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CORE_AUTH_VERIFY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CORE_LOAD_ALL_DISPLAY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CORE_LOAD_ALL_DISPLAY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CORE_LOAD_ALL_DISPLAY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CORE_FIND_DISPLAY_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CORE_FIND_DISPLAY_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CORE_FIND_DISPLAY_INFO_FAILURE; });
var REQUEST_STATE = 'REQUEST_STATE';
var SET_ERROR = 'SET_ERROR';

var LOGOUT = 'LOGOUT';

//AUTH
var CORE_AUTH_VERIFY_REQUEST = 'CORE_AUTH_VERIFY_REQUEST';
var CORE_AUTH_VERIFY_SUCCESS = 'CORE_AUTH_VERIFY_SUCCESS';
var CORE_AUTH_VERIFY_FAILURE = 'CORE_AUTH_VERIFY_FAILURE';

// DISPLAY
var CORE_LOAD_ALL_DISPLAY_REQUEST = 'CORE_LOAD_ALL_DISPLAY_REQUEST';
var CORE_LOAD_ALL_DISPLAY_SUCCESS = 'CORE_LOAD_ALL_DISPLAY_SUCCESS';
var CORE_LOAD_ALL_DISPLAY_FAILURE = 'CORE_LOAD_ALL_DISPLAY_FAILURE';

var CORE_FIND_DISPLAY_INFO_REQUEST = 'CORE_FIND_DISPLAY_INFO_REQUEST';
var CORE_FIND_DISPLAY_INFO_SUCCESS = 'CORE_FIND_DISPLAY_INFO_SUCCESS';
var CORE_FIND_DISPLAY_INFO_FAILURE = 'CORE_FIND_DISPLAY_INFO_FAILURE';

/***/ }),

/***/ 192:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./src/lib/api.js

// export const CORE_API_ENDPOINT = 'http://localhost:2000'

var CORE_API_ENDPOINT = '/api';
// 
// export const CORE_API_ENDPOINT = 'https://tbqapi.rmbainisys.com'
// EXTERNAL MODULE: ./node_modules/base-64/base64.js
var base64 = __webpack_require__(744);
var base64_default = /*#__PURE__*/__webpack_require__.n(base64);

// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(745);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(4);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./src/lib/auth.js
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var TOKEN = 'token';
var EXPIRES_ON = 'expires_on';
var EXPIRES_DATE = 'expires_date';
var USER_ID = 'user_id';
var REDIRECT_URL = 'redirectUrl';
var CLIENT_ID = 'clientId';
var USER_FULLNAME = 'fullName';
var USER_ROLE = 'userRole';
var expiresDay = 7;

function getCookie(key) {
    var value = js_cookie_default.a.get(key);
    var setValue = '';
    if (typeof value === 'string') {
        setValue = base64_default.a.decode(value);
    }
    return setValue;
}

function setCookie(key, value, expires) {
    var valueToString = String(value);
    var setValue = '';
    if (typeof valueToString === 'string') {
        setValue = base64_default.a.encode(valueToString);
    }
    if (expires && typeof expires === "number" && expires > 0) {
        js_cookie_default.a.set(key, setValue, { expires: expires });
    } else {
        js_cookie_default.a.set(key, setValue);
    }
}

function removeCookie(key) {
    js_cookie_default.a.remove(key);
}

function authentication(dataAuth, isRemember) {
    if (dataAuth && dataAuth.result === true) {
        var data = dataAuth.data;

        if (data && data.user) {
            clearToken();
            var user = data.user,
                token = data.token,
                expiresOn = data.expiresOn,
                expiresDate = data.expiresDate;

            var setExpiresDay = expiresDay;
            if (isRemember === false) {
                setExpiresDay = 0;
            }
            if (token) setCookie(TOKEN, token, setExpiresDay);
            if (expiresOn) setCookie(EXPIRES_ON, expiresOn, setExpiresDay);
            if (expiresDate) setCookie(EXPIRES_DATE, expiresDate, setExpiresDay);
            if (user && user.id) setCookie(USER_ID, user.id, setExpiresDay);
            if (user && user.fullName) {
                setCookie(USER_FULLNAME, user.fullName, setExpiresDay);
            }
            if (user && user.role && user.role.code) {
                setCookie(USER_ROLE, user.role.name, setExpiresDay);
            }
        } else if (dataAuth.token) {
            setCookie(TOKEN, dataAuth.token, dataAuth.expires_on);
            if (dataAuth.expires_on) setCookie(EXPIRES_ON, dataAuth.expires_on, dataAuth.expires_on);
        }
    }
}

function clearToken() {
    removeCookie(TOKEN);
    removeCookie(EXPIRES_ON);
    removeCookie(EXPIRES_DATE);
    removeCookie(USER_ID);
    removeCookie(USER_FULLNAME);
    removeCookie(REDIRECT_URL);
    removeCookie(CLIENT_ID);
    removeCookie(USER_ROLE);
}

function getAllCookies() {
    var _ref;

    return _ref = {}, _defineProperty(_ref, TOKEN, getCookie(TOKEN)), _defineProperty(_ref, EXPIRES_ON, getCookie(EXPIRES_ON)), _defineProperty(_ref, EXPIRES_DATE, getCookie(EXPIRES_DATE)), _defineProperty(_ref, USER_ID, getCookie(USER_ID)), _ref;
}

function getToken() {
    return getCookie(TOKEN);
}

function getUserFullName() {
    return getCookie(USER_FULLNAME);
}

function getUserRole() {
    return getCookie(USER_ROLE);
}

function setBackendInfoCookie(_ref2) {
    var redirectUrl = _ref2.redirectUrl,
        clientId = _ref2.clientId;

    setCookie(REDIRECT_URL, redirectUrl);
    setCookie(CLIENT_ID, clientId);
}

function getBackendInfoCookie() {
    return { redirectUrl: getCookie(REDIRECT_URL), clientId: getCookie(CLIENT_ID) };
}

function setDefaultCookie() {
    authentication({
        result: true,
        data: {
            user: {
                id: "01",
                fullName: "User Test",
                role: {
                    code: "01",
                    name: "Admin 1"
                }
            },
            token: "assaaddffd",
            expiresOn: "",
            expiresDate: moment_default()().add(50, "day")
        }
    });
}
// CONCATENATED MODULE: ./src/lib/setting.js
var timeZone = 'Asia/Bangkok';
var timeFormat = 'YYYY-MM-DDTHH:mm:ss';
var defaultDateFormat = 'MMMM DD, YYYY';
var defaultDateTimeFormat = 'MMMM DD, YYYY HH:mm';
// CONCATENATED MODULE: ./src/lib/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return CORE_API_ENDPOINT; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return TOKEN; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return EXPIRES_ON; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return EXPIRES_DATE; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return USER_ID; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return REDIRECT_URL; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return CLIENT_ID; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return USER_FULLNAME; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return USER_ROLE; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return authentication; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return clearToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "f", function() { return getAllCookies; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "g", function() { return getToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "h", function() { return getUserFullName; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "i", function() { return getUserRole; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return setBackendInfoCookie; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getBackendInfoCookie; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return setDefaultCookie; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return timeZone; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return timeFormat; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return defaultDateFormat; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return defaultDateTimeFormat; });




/***/ }),

/***/ 516:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/mongoose/dist/browser.umd.js
var browser_umd = __webpack_require__(435);
var browser_umd_default = /*#__PURE__*/__webpack_require__.n(browser_umd);

// CONCATENATED MODULE: ./src/app/model/Schema.js
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



var setBaseSchema = function setBaseSchema(schema) {
	var code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "00";


	schema.set("toJSON", { getters: true, virtuals: true });
	schema.set("toObject", { getters: false, virtuals: true });

	schema.virtual('ModelCode').get(function () {
		return code;
	});

	schema.methods.hasError = function () {
		try {
			return !!this.errors;
		} catch (error) {
			return false;
		}
	};

	schema.methods.getErrors = function () {
		try {
			var token = [];
			if (this.hasError()) {
				var allPath = [];
				for (var path in this.errors) {
					allPath.push(path);
				}

				allPath = allPath.reduce(function (r, e, i, s) {
					if (s.filter(function (f) {
						return f != e && !!f.match(new RegExp(e));
					}).length == 0) {
						r.push(e);
					}

					return r;
				}, []);

				for (var i = 0; i < allPath.length; i++) {
					var _path = allPath[i];
					token.push({
						path: _path,
						code: "0500" + (this.ModelCode ? this.ModelCode : "00") + "00",
						message: this.errors[_path].message
					});
				}
			}

			if (token.length > 0) return token;
		} catch (error) {}

		return null;
	};

	schema.methods.beforeCreate = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						return _context.abrupt("return", true);

					case 1:
					case "end":
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	schema.methods.beforeUpdate = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
		return regeneratorRuntime.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						return _context2.abrupt("return", true);

					case 1:
					case "end":
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	schema.methods.beforeDelete = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
		return regeneratorRuntime.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						return _context3.abrupt("return", true);

					case 1:
					case "end":
						return _context3.stop();
				}
			}
		}, _callee3, this);
	}));

	schema.methods.afterCreate = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
		return regeneratorRuntime.wrap(function _callee4$(_context4) {
			while (1) {
				switch (_context4.prev = _context4.next) {
					case 0:
					case "end":
						return _context4.stop();
				}
			}
		}, _callee4, this);
	}));

	schema.methods.afterUpdate = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
		return regeneratorRuntime.wrap(function _callee5$(_context5) {
			while (1) {
				switch (_context5.prev = _context5.next) {
					case 0:
					case "end":
						return _context5.stop();
				}
			}
		}, _callee5, this);
	}));

	schema.methods.afterDelete = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
		return regeneratorRuntime.wrap(function _callee6$(_context6) {
			while (1) {
				switch (_context6.prev = _context6.next) {
					case 0:
					case "end":
						return _context6.stop();
				}
			}
		}, _callee6, this);
	}));

	schema.methods.serialize = function () {
		try {
			var result = this.toJSON();

			if ("_id" in result) delete result["_id"];
			if ("createBy" in result) delete result["createBy"];
			if ("createDate" in result) delete result["createDate"];
			if ("updateBy" in result) delete result["updateBy"];
			if ("updateDate" in result) delete result["updateDate"];
			if ("isVoid" in result) delete result["isVoid"];
			if ("ModelCode" in result) delete result["ModelCode"];
			if ("__v" in result) delete result["__v"];

			return result;
		} catch (error) {
			return null;
		}
	};

	schema.methods.serializeAPI = function () {
		try {
			return null;
		} catch (error) {
			return null;
		}
	};

	schema.methods.setData = function () {
		try {} catch (error) {}
	};

	schema.methods.validateError = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
		var error;
		return regeneratorRuntime.wrap(function _callee7$(_context7) {
			while (1) {
				switch (_context7.prev = _context7.next) {
					case 0:
						_context7.prev = 0;
						_context7.next = 3;
						return this.validate();

					case 3:
						error = _context7.sent;

						if (!error) {
							this.errors = null;
						}
						_context7.next = 9;
						break;

					case 7:
						_context7.prev = 7;
						_context7.t0 = _context7["catch"](0);

					case 9:
						return _context7.abrupt("return", !this.hasError());

					case 10:
					case "end":
						return _context7.stop();
				}
			}
		}, _callee7, this, [[0, 7]]);
	}));
};

var Schema_addError = function addError(model, path, message) {
	var error = new browser_umd_default.a.Error.ValidatorError({ message: message, type: "", path: path });
	if (model.errors && _typeof(model.errors) == "object") {
		model.errors["id"] = error;
	} else {
		model.errors = { id: error };
	}
};

var addDataInUsedError = function addDataInUsedError(model) {
	Schema_addError(model, "id", "Data in used");
};


// EXTERNAL MODULE: ./node_modules/react-switch-lang/index.js
var react_switch_lang = __webpack_require__(106);
var react_switch_lang_default = /*#__PURE__*/__webpack_require__.n(react_switch_lang);

// CONCATENATED MODULE: ./src/app/model/displayModel.js




var Schema = browser_umd_default.a.Schema;

var DisplaySchema = new Schema({
    id: { type: String, required: false, default: null },
    mac: { type: String, required: [true, 'validate.require'] },
    // model: { type: String, required: false, default: null },
    // ipAddress: { type: String, required: false, default: null },
    room: { type: Object, required: false, default: null },
    status: { type: String, required: false, default: null }
});

setBaseSchema(DisplaySchema, "03");

DisplaySchema.methods.serializeAPI = function () {
    try {
        var result = {
            mac: this.mac,
            room: this.room,
            status: this.status
        };

        return result;
    } catch (error) {
        return null;
    }
};

DisplaySchema.methods.setData = function (data) {
    try {
        this.id = data.id;
        this.mac = data.mac;
        this.room = data.room;
        this.status = data.status;
    } catch (error) {}
};

/************************************************************************
 * 
 * Validator Method
 * 
 *************************************************************************/
var DisplayModel = browser_umd_default.a.model("display", DisplaySchema, "display");

/* harmony default export */ var displayModel = __webpack_exports__["a"] = (DisplayModel);

/***/ }),

/***/ 518:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./src/middlewares/api.js
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var CALL_API = Symbol('CALL_API');

var resStatusError = [400, 401, 402, 403, 404, 422, 500, 501, 502, 503];

function getAction(type, action, state, res) {
    return new Promise(function (resolve, reject) {
        if (!res) return resolve({ type: type });

        if (resStatusError.includes(res.status)) {
            // const data = getResError(res)
            // return reject({ statusText: res.statusText, ...data })

            // if (res.status === 422) {
            //     res
            //         .json()
            //         .then(json => {
            //             var message = []
            //             for (const key in json) {
            //                 if (json.hasOwnProperty(key)) {
            //                     const element = json[key];
            //                     for (const k in element) {
            //                         if (element.hasOwnProperty(k)) {
            //                             const ele = element[k];

            //                             if (ele.param) {
            //                                 message.push({
            //                                     param: ele.param,
            //                                     message: ele.msg
            //                                 })
            //                             }
            //                         }
            //                     }

            //                 }
            //             }

            //             return reject({ statusCode: res.status, statusText: res.statusText, code: '', message: message, errorList: state.errorList })
            //         })
            // } else {
            //     res
            //         .json()
            //         .then(json => {
            //             return reject({ statusCode: res.status, statusText: res.statusText, ...json, errorList: state.errorList })
            //         })
            // }
            return reject({ statusCode: res.status, statusText: res.statusText, errorList: state.errorList });
        }

        if ((typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'object') {
            if (type.payload) {
                var payload = type.payload(action, state, res);
                if (typeof payload.then === 'function') {
                    //promise
                    return payload.then(function (data) {
                        return resolve({ type: type.type, payload: data });
                    });
                } else {
                    return resolve({ type: type.type, payload: payload });
                }
            }

            return resolve({ type: type.type });
        }

        res.json().then(function (payload) {
            return resolve({ type: type, payload: payload });
        });
    });
}

/* harmony default export */ var api = (function (_ref) {
    var getState = _ref.getState;
    return function (next) {
        return function (action) {
            if (_typeof(action[CALL_API]) !== 'object') return next(action);
            var _action$CALL_API = action[CALL_API],
                endpoint = _action$CALL_API.endpoint,
                _action$CALL_API$meth = _action$CALL_API.method,
                method = _action$CALL_API$meth === undefined ? 'GET' : _action$CALL_API$meth,
                headers = _action$CALL_API.headers,
                body = _action$CALL_API.body,
                types = _action$CALL_API.types;

            var _types = _slicedToArray(types, 3),
                request = _types[0],
                success = _types[1],
                failure = _types[2];

            var callBack = success.callBack;

            var state = getState();

            getAction(request, action, state).then(function (action) {
                return next(action);
            });

            if (callBack) {
                fetch(endpoint, { method: method, headers: headers, body: body }).then(function (res) {
                    return getAction(success, action, state, res);
                }).then(function (action) {
                    callBack(action);
                    next(action);
                }).catch(function (err) {
                    return next({ type: failure, payload: err, error: true, errorData: err.data });
                });
            } else {
                fetch(endpoint, { method: method, headers: headers, body: body }).then(function (res) {
                    return getAction(success, action, state, res);
                }).then(function (action) {
                    return next(action);
                }).catch(function (err) {
                    return next({ type: failure, payload: err, error: true, errorData: err.data });
                });
            }
        };
    };
});
// EXTERNAL MODULE: ./src/lib/index.js + 3 modules
var lib = __webpack_require__(192);

// CONCATENATED MODULE: ./src/middlewares/checkToken.js
var checkToken__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };


// import moment from 'moment'


/* harmony default export */ var checkToken = (function (store) {
    return function (next) {
        return function (action) {
            var entry = action[CALL_API];

            if ((typeof entry === 'undefined' ? 'undefined' : checkToken__typeof(entry)) !== 'object') return next(action);

            var allCookies = Object(lib["f" /* getAllCookies */])();

            if (allCookies && allCookies[lib["b" /* EXPIRES_ON */]]) {
                // const currentTime = moment()
                //     , expireDate = moment.unix(allCookies[EXPIRES_ON])
                // if (expireDate.isValid()) {

                // } else {
                //     next(action)
                // }
                next(action);
            } else {
                next(action);
            }
            // const expire = getTokenExpire() //EXPIRES_ON

            // const currentTime = moment().tz(getTimeZone())
            // const duration = moment.duration(moment.unix(expire).diff(currentTime))
            // const minutes = duration.asMinutes()
            // if (minutes < 5) {
            //     fetch(`${CORE_API_ENDPOINT}/user/newtoken`, {
            //         method: 'POST',
            //         headers: {
            //             'Content-Type': 'application/json',
            //             // 'Authorization': `Bearer ${getBSRSToken()}`
            //         },
            //         body: JSON.stringify({
            //             'id': getUserId()
            //         })
            //     })
            //         .then(res => res.json())
            //         .then(json => setRefreshToken(json))
            //         .then(() => next(action))
            // } else {
            //     next(action)
            // }

        };
    };
});
// CONCATENATED MODULE: ./src/middlewares/setToken.js
var setToken__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };




/* harmony default export */ var setToken = (function (store) {
    return function (next) {
        return function (action) {

            var entry = action[CALL_API];
            // const ignorTypes  = [types.]
            if ((typeof entry === 'undefined' ? 'undefined' : setToken__typeof(entry)) !== 'object') return next(action);

            var token = null;
            var allCookies = Object(lib["f" /* getAllCookies */])();
            if (allCookies && allCookies[lib["c" /* TOKEN */]]) {
                token = allCookies[lib["c" /* TOKEN */]];
            }

            if (!token) return next(action);

            if (token) {
                entry.headers.Authorization = 'Bearer ' + token;
            }
            entry.headers["Access-Control-Allow-Origin"] = "*";
            entry.headers["Access-Control-Allow-Methods"] = "*";
            entry.headers["Access-Control-Allow-Headers"] = "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With";
            next(action);
        };
    };
});
// CONCATENATED MODULE: ./src/middlewares/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return api; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return CALL_API; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return checkToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return setToken; });




/***/ }),

/***/ 519:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_switch_lang__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_switch_lang___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_switch_lang__);




var LoadingInline = function LoadingInline(_ref) {
    var t = _ref.t;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'module loadingInline' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["k" /* Loader */],
            { active: true, inline: 'centered', size: 'large' },
            t("share.loading")
        )
    );
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_switch_lang__["translate"])(LoadingInline));

/***/ }),

/***/ 520:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_switch_lang__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_switch_lang___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_switch_lang__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var ModalTypes = ["general", "error", "warning", "danger"];

var AlertModal = function (_React$Component) {
    _inherits(AlertModal, _React$Component);

    function AlertModal() {
        _classCallCheck(this, AlertModal);

        return _possibleConstructorReturn(this, (AlertModal.__proto__ || Object.getPrototypeOf(AlertModal)).apply(this, arguments));
    }

    _createClass(AlertModal, [{
        key: 'render',

        // actions = [ { text:"", className:"", action:()=> {} } ]
        value: function render() {
            var _props = this.props,
                open = _props.open,
                size = _props.size,
                type = _props.type,
                header = _props.header,
                content = _props.content,
                actions = _props.actions,
                close = _props.close,
                t = _props.t,
                color = _props.color;


            var modalSize = "tiny"
            // , modalHeaderIcon = null
            ,
                modalHeaderText = t("share.system"),
                modalHeaderAction = null,
                modalActionButtons = [],
                modalContent = null,
                modalType = "general";

            if (size) {
                modalSize = size;
            }

            if (header) {
                modalHeaderText = header;
            }

            if (type && ModalTypes.includes(type)) {
                modalType = type;
            }

            // if (modalType === "error") {
            //     modalHeaderIcon = <Icon name="close" color="red" />
            // } else if (modalType === "warning") {
            //     modalHeaderIcon = <Icon name="question" color="yellow" />
            // } else {
            //     modalHeaderIcon = null
            // }

            modalHeaderAction = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Icon */], { name: 'close', color: color, className: 'iconClose error', onClick: close });

            if (Array.isArray(actions) && actions.length > 0) {
                modalActionButtons = actions.map(function (btn, i) {
                    var isDisabled = false;
                    if (typeof btn.disabled === "boolean") {
                        isDisabled = btn.disabled;
                    }

                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Button */],
                        { key: i, className: btn.className, onClick: btn.action, disabled: isDisabled },
                        btn.text
                    );
                });
            }

            if (content) {
                modalContent = content;
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["m" /* Modal */],
                    {
                        open: open,
                        onClose: close,
                        size: modalSize,
                        className: 'module alertModal'
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["m" /* Modal */].Header,
                        { className: 'header-' + modalType },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'headerBox' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'text ' + modalType },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'p',
                                    null,
                                    modalHeaderText
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'action ' + modalType },
                                modalHeaderAction
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["m" /* Modal */].Content,
                        { scrolling: true },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["m" /* Modal */].Description,
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'contentBox' },
                                modalContent
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["m" /* Modal */].Actions,
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'actionBox' },
                            modalActionButtons
                        )
                    )
                )
            );
        }
    }]);

    return AlertModal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_switch_lang__["translate"])(AlertModal));

/***/ }),

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(522);


/***/ }),

/***/ 522:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-polyfill/lib/index.js
var lib = __webpack_require__(258);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(137);
var react_dom_default = /*#__PURE__*/__webpack_require__.n(react_dom);

// EXTERNAL MODULE: ./node_modules/react-hot-loader/index.js
var react_hot_loader = __webpack_require__(728);
var react_hot_loader_default = /*#__PURE__*/__webpack_require__.n(react_hot_loader);

// EXTERNAL MODULE: ./node_modules/react-router-dom/esm/react-router-dom.js + 5 modules
var react_router_dom = __webpack_require__(141);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 15 modules
var es = __webpack_require__(52);

// EXTERNAL MODULE: ./node_modules/normalizr/dist/normalizr.es.js
var normalizr_es = __webpack_require__(740);

// CONCATENATED MODULE: ./src/store/schema.js


var eventSchema = new normalizr_es["a" /* schema */].Entity('events');
// EXTERNAL MODULE: ./src/store/configureStore.js
var configureStore = __webpack_require__(741);
var configureStore_default = /*#__PURE__*/__webpack_require__.n(configureStore);

// CONCATENATED MODULE: ./src/store/index.js


// EXTERNAL MODULE: ./node_modules/react-loadable/lib/index.js
var react_loadable_lib = __webpack_require__(770);
var react_loadable_lib_default = /*#__PURE__*/__webpack_require__.n(react_loadable_lib);

// EXTERNAL MODULE: ./src/app/components/features/share/loadingInline.js
var loadingInline = __webpack_require__(519);

// CONCATENATED MODULE: ./src/app/components/features/share/loadable/loadableRoute.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var loadableRoute_Loading = function Loading() {
    return react_default.a.createElement(
        'div',
        { className: 'module loadableRoute' },
        react_default.a.createElement(loadingInline["a" /* default */], null)
    );
};

/* harmony default export */ var loadableRoute = (function (opts) {
    return react_loadable_lib_default()(_extends({
        loading: loadableRoute_Loading
    }, opts));
});
// EXTERNAL MODULE: ./src/lib/index.js + 3 modules
var src_lib = __webpack_require__(192);

// CONCATENATED MODULE: ./src/app/routes/routePermission.js
var routePermission__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var Auth = {
	isAuthenticated: function isAuthenticated() {
		var cookies = Object(src_lib["f" /* getAllCookies */])();

		var isAuth = false;

		if (cookies && cookies[src_lib["c" /* TOKEN */]] /*&& cookies[USER_ID]*/) {
				isAuth = true;
			}

		return isAuth;
	}
};

var routePermission_PrivateRoute = function PrivateRoute(_ref) {
	var Component = _ref.component,
	    Layout = _ref.layout,
	    staticContext = _ref.staticContext,
	    rest = _objectWithoutProperties(_ref, ['component', 'layout', 'staticContext']);

	return react_default.a.createElement(react_router_dom["c" /* Route */], routePermission__extends({}, rest, { render: function render(props) {
			if (Auth.isAuthenticated() === false && props.match.url !== "/login") {
				return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/login' });
			}

			if (Layout) {
				return react_default.a.createElement(Layout, routePermission__extends({}, props, { Component: Component }));
			} else {
				if (Component !== undefined) {
					return react_default.a.createElement(Component, props);
				} else {
					return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/' });
				}
			}
		} }));
};

var routePermission_PublicRoute = function PublicRoute(_ref2) {
	var Component = _ref2.component,
	    Layout = _ref2.layout,
	    staticContext = _ref2.staticContext,
	    rest = _objectWithoutProperties(_ref2, ['component', 'layout', 'staticContext']);

	return react_default.a.createElement(react_router_dom["c" /* Route */], routePermission__extends({}, rest, { render: function render(props) {

			if (Auth.isAuthenticated() === true && props.match.url === "/login") {
				return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/' });
			}

			if (Layout) {
				return react_default.a.createElement(Layout, routePermission__extends({}, props, { Component: Component }));
			} else {
				if (Component !== undefined) {
					return react_default.a.createElement(Component, props);
				} else {
					return null;
				}
			}
		} }));
};


// CONCATENATED MODULE: ./src/app/routes/Routes.js





//Layout
var LayoutWithSidebar = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 1235));
    }
});
var LayoutBlank = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 1236));
    }
});

//Features
//Auth
var LoginController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1237));
    }
});

var NotFoundController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 1238));
    }
});
var HomeController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1239));
    }
});

// Display
var DisplayList = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1240));
    }
});

var DisplayCreate = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1241));
    }
});

var DisplayUpdate = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1242));
    }
});

var DisplayView = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1243));
    }
});

// Control Display Schedule
var ControleDisplayScheduleList = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1244));
    }
});

/* harmony default export */ var Routes = (function () {
    return react_default.a.createElement(
        react_router_dom["d" /* Switch */],
        null,
        react_default.a.createElement(routePermission_PrivateRoute, { exact: true, path: '/', component: HomeController, layout: LayoutWithSidebar }),
        react_default.a.createElement(routePermission_PublicRoute, { exact: true, path: '/login', component: LoginController, layout: LayoutBlank }),
        react_default.a.createElement(routePermission_PrivateRoute, { exact: true, path: '/display/view/:id', component: DisplayView, layout: LayoutWithSidebar }),
        react_default.a.createElement(routePermission_PrivateRoute, { exact: true, path: '/display/edit/:id', component: DisplayUpdate, layout: LayoutWithSidebar }),
        react_default.a.createElement(routePermission_PrivateRoute, { exact: true, path: '/display/create', component: DisplayCreate, layout: LayoutWithSidebar }),
        react_default.a.createElement(routePermission_PrivateRoute, { exact: true, path: '/display', component: DisplayList, layout: LayoutWithSidebar }),
        react_default.a.createElement(routePermission_PrivateRoute, { exact: true, path: '/controldisplay', component: ControleDisplayScheduleList, layout: LayoutWithSidebar }),
        react_default.a.createElement(routePermission_PrivateRoute, { component: NotFoundController, layout: LayoutWithSidebar })
    );
});
// CONCATENATED MODULE: ./src/app/routes/App.js




/* harmony default export */ var App = (function () {
    return react_default.a.createElement(Routes, null);
});
// EXTERNAL MODULE: ./node_modules/recompose/es/Recompose.js
var Recompose = __webpack_require__(515);

// EXTERNAL MODULE: ./node_modules/react-switch-lang/index.js
var react_switch_lang = __webpack_require__(106);
var react_switch_lang_default = /*#__PURE__*/__webpack_require__.n(react_switch_lang);

// EXTERNAL MODULE: ./node_modules/semantic-ui-react/dist/es/index.js + 262 modules
var dist_es = __webpack_require__(136);

// EXTERNAL MODULE: ./src/app/redux/types.js
var types = __webpack_require__(142);

// CONCATENATED MODULE: ./src/app/redux/actions/actionsCallAPI.js
var actionsCallAPI__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// import { CALL_API } from 'Middlewares'


function actionsCallAPI_setError(errorList, newError, isShow) {
	var mapError = [];
	if (errorList && Array.isArray(errorList)) {
		if (isShow === true) {
			errorList.forEach(function (e) {
				mapError.push(actionsCallAPI__extends({}, e, { isShow: true }));
			});
		} else {
			mapError = mapError.concat(errorList);
		}
	}
	if (newError) {
		mapError.push(actionsCallAPI__extends({}, newError, { isShow: false }));
	}
	return {
		type: types["n" /* SET_ERROR */],
		error: mapError
	};
}
// CONCATENATED MODULE: ./src/app/redux/selectors/selectorCallAPI.js
function getErrorList(state) {
    return state.errorList;
}
// EXTERNAL MODULE: ./src/app/components/features/share/modal/alertModal.js
var alertModal = __webpack_require__(520);

// CONCATENATED MODULE: ./src/app/components/features/share/modal/modalErrorNoSuccess.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var modalErrorNoSuccess_ModalErrorNoSuccess = function (_React$Component) {
    _inherits(ModalErrorNoSuccess, _React$Component);

    function ModalErrorNoSuccess(props) {
        _classCallCheck(this, ModalErrorNoSuccess);

        var _this = _possibleConstructorReturn(this, (ModalErrorNoSuccess.__proto__ || Object.getPrototypeOf(ModalErrorNoSuccess)).call(this, props));

        _this.state = {};
        return _this;
    }

    _createClass(ModalErrorNoSuccess, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var errorList = this.props.errorList;


            var openModal = false,
                mapErrorList = [];
            if (errorList && Array.isArray(errorList) && errorList.length > 0) {
                var findeError = errorList.find(function (e) {
                    return e.isShow === true;
                });
                if (!findeError) {
                    openModal = true;
                }
                mapErrorList = errorList;
            }

            return react_default.a.createElement(
                react_default.a.Fragment,
                null,
                react_default.a.createElement(alertModal["a" /* default */], {
                    type: 'error',
                    open: openModal,
                    size: "tiny",
                    close: function close() {
                        return _this2.props.setError(errorList, null, true);
                    }
                    // header={textHeaderModal}
                    , content: react_default.a.createElement(
                        'div',
                        { className: '' },
                        react_default.a.createElement(
                            dist_es["j" /* List */],
                            { divided: true, relaxed: true },
                            mapErrorList.map(function (d, i) {
                                return react_default.a.createElement(
                                    dist_es["j" /* List */].Item,
                                    { key: i },
                                    react_default.a.createElement(
                                        dist_es["g" /* Grid */],
                                        null,
                                        react_default.a.createElement(
                                            dist_es["g" /* Grid */].Row,
                                            null,
                                            react_default.a.createElement(
                                                dist_es["g" /* Grid */].Column,
                                                { width: 16 },
                                                react_default.a.createElement(
                                                    'p',
                                                    null,
                                                    d.statusCode,
                                                    ' ',
                                                    d.statusText
                                                )
                                            )
                                        )
                                    )
                                );
                            })
                        )
                    ),
                    actions: [{ text: "Close", className: "btn cancel", action: function action() {
                            return _this2.props.setError(errorList, null, true);
                        } }]
                })
            );
        }
    }]);

    return ModalErrorNoSuccess;
}(react_default.a.Component);

/* harmony default export */ var modalErrorNoSuccess = (Object(Recompose["a" /* compose */])(react_router_dom["e" /* withRouter */], react_switch_lang["translate"], Object(es["connect"])(function (state, props) {
    return {
        errorList: getErrorList(state)
    };
}, function (dispatch, _ref) {
    var history = _ref.history;
    return {
        setError: function setError(errorList, newError, isShow) {
            dispatch(actionsCallAPI_setError(errorList, newError, isShow));
        }
    };
}), Object(Recompose["b" /* lifecycle */])({
    componentDidMount: function componentDidMount() {
        // this.props.setError(this.errorList, { code: '000000', message: '000000' }, false)
    }
}))(modalErrorNoSuccess_ModalErrorNoSuccess));
// CONCATENATED MODULE: ./src/app/components/features/share/ErrorBoundary.js
var ErrorBoundary__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ErrorBoundary__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ErrorBoundary__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ErrorBoundary__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


// import { withRouter } from 'react-router-dom'
// import { compose } from 'recompose'


var ErrorBoundary_ErrorBoundary = function (_React$Component) {
    ErrorBoundary__inherits(ErrorBoundary, _React$Component);

    function ErrorBoundary(props) {
        ErrorBoundary__classCallCheck(this, ErrorBoundary);

        var _this = ErrorBoundary__possibleConstructorReturn(this, (ErrorBoundary.__proto__ || Object.getPrototypeOf(ErrorBoundary)).call(this, props));

        _this.handleSubmit = function () {
            window.location.replace('/');
            // this.props.history.replace(`/`)
        };

        _this.state = {
            error: null, errorInfo: null
        };
        return _this;
    }

    ErrorBoundary__createClass(ErrorBoundary, [{
        key: 'componentDidCatch',
        value: function componentDidCatch(error, errorInfo) {
            this.setState({
                error: error,
                errorInfo: errorInfo
            });
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.state.errorInfo) {
                // Error path
                return react_default.a.createElement(
                    'div',
                    { className: 'module errorBoundary' },
                    react_default.a.createElement(
                        dist_es["c" /* Container */],
                        null,
                        react_default.a.createElement(
                            dist_es["g" /* Grid */],
                            { className: 'grid-header' },
                            react_default.a.createElement(
                                dist_es["g" /* Grid */].Column,
                                { width: 16, textAlign: 'center' },
                                react_default.a.createElement(
                                    'h2',
                                    null,
                                    'Something went wrong.'
                                )
                            ),
                            react_default.a.createElement(
                                dist_es["g" /* Grid */].Column,
                                { width: 16, textAlign: 'center' },
                                react_default.a.createElement(
                                    dist_es["a" /* Button */],
                                    { className: 'btn _back', onClick: this.handleSubmit },
                                    'Back'
                                )
                            ),
                            react_default.a.createElement(
                                dist_es["g" /* Grid */].Column,
                                { width: 16 },
                                react_default.a.createElement(
                                    'details',
                                    { style: { whiteSpace: 'pre-wrap' } },
                                    this.state.error && this.state.error.toString(),
                                    react_default.a.createElement('br', null),
                                    this.state.errorInfo.componentStack
                                )
                            )
                        )
                    )
                );
            }
            return this.props.children;
        }
    }]);

    return ErrorBoundary;
}(react_default.a.Component);

// export default compose(
//     withRouter
// )(ErrorBoundary)


/* harmony default export */ var share_ErrorBoundary = (ErrorBoundary_ErrorBoundary);
// EXTERNAL MODULE: ./src/app/components/scss/index.scss
var scss = __webpack_require__(999);
var scss_default = /*#__PURE__*/__webpack_require__.n(scss);

// CONCATENATED MODULE: ./src/app/routes/Root.js










var store = configureStore_default()();

/* harmony default export */ var Root = (function () {
    return react_default.a.createElement(
        es["Provider"],
        { store: store },
        react_default.a.createElement(
            react_router_dom["a" /* BrowserRouter */],
            null,
            react_default.a.createElement(
                react_default.a.Fragment,
                null,
                react_default.a.createElement(
                    share_ErrorBoundary,
                    null,
                    react_default.a.createElement(App, null),
                    react_default.a.createElement(modalErrorNoSuccess, null)
                )
            )
        )
    );
});
// EXTERNAL MODULE: ./src/language/en/common.json
var common = __webpack_require__(1009);
var common_default = /*#__PURE__*/__webpack_require__.n(common);

// EXTERNAL MODULE: ./src/language/en/display.json
var display = __webpack_require__(1010);
var display_default = /*#__PURE__*/__webpack_require__.n(display);

// EXTERNAL MODULE: ./src/language/en/controlDisplaySchedule.json
var controlDisplaySchedule = __webpack_require__(1011);
var controlDisplaySchedule_default = /*#__PURE__*/__webpack_require__.n(controlDisplaySchedule);

// EXTERNAL MODULE: ./src/language/en/validate.json
var validate = __webpack_require__(1012);
var validate_default = /*#__PURE__*/__webpack_require__.n(validate);

// CONCATENATED MODULE: ./src/language/en.js
var en__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






/* harmony default export */ var en = (en__extends({}, common_default.a, {
   "display": en__extends({}, display_default.a),
   "controlDosplaySchedule": en__extends({}, controlDisplaySchedule_default.a),
   "validate": en__extends({}, validate_default.a)
}));
// EXTERNAL MODULE: ./src/language/th/common.json
var th_common = __webpack_require__(1013);
var th_common_default = /*#__PURE__*/__webpack_require__.n(th_common);

// EXTERNAL MODULE: ./src/language/th/display.json
var th_display = __webpack_require__(1014);
var th_display_default = /*#__PURE__*/__webpack_require__.n(th_display);

// EXTERNAL MODULE: ./src/language/th/controlDisplaySchedule.json
var th_controlDisplaySchedule = __webpack_require__(1015);
var th_controlDisplaySchedule_default = /*#__PURE__*/__webpack_require__.n(th_controlDisplaySchedule);

// EXTERNAL MODULE: ./src/language/th/validate.json
var th_validate = __webpack_require__(1016);
var th_validate_default = /*#__PURE__*/__webpack_require__.n(th_validate);

// CONCATENATED MODULE: ./src/language/th.js
var th__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






/* harmony default export */ var th = (th__extends({}, th_common_default.a, {
   "display": th__extends({}, th_display_default.a),
   "controlDosplaySchedule": th__extends({}, th_controlDisplaySchedule_default.a),
   "validate": th__extends({}, th_validate_default.a)
}));
// CONCATENATED MODULE: ./src/index.js










Object(react_switch_lang["setTranslations"])({ en: en, th: th });

Object(react_switch_lang["setDefaultLanguage"])('th');

if (Object(react_switch_lang["getLanguage"])() === 'th' || Object(react_switch_lang["getLanguage"])() === 'en') {
    Object(react_switch_lang["setLanguage"])(Object(react_switch_lang["getLanguage"])());
}

Object(react_switch_lang["setLanguageCookie"])('language', { maxAge: 86400 }, undefined);

var src_render = function render(Component) {
    react_dom_default.a.render(react_default.a.createElement(
        react_hot_loader["AppContainer"],
        null,
        react_default.a.createElement(Component, null)
    ), document.getElementById('root'));
};

src_render(Root);
if (false) {
    module.hot.accept('./app/routes/Root', function () {
        return src_render(RootContainer);
    });
}

/***/ }),

/***/ 741:
/***/ (function(module, exports, __webpack_require__) {

if (true) {
    module.exports = __webpack_require__(742);
} else {
    module.exports = require('./configureStore.dev');
}

/***/ }),

/***/ 742:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/redux/es/index.js + 6 modules
var es = __webpack_require__(114);

// EXTERNAL MODULE: ./node_modules/redux-thunk/es/index.js
var redux_thunk_es = __webpack_require__(743);

// EXTERNAL MODULE: ./src/middlewares/index.js + 3 modules
var src_middlewares = __webpack_require__(518);

// EXTERNAL MODULE: ./node_modules/redux-form/es/index.js + 228 modules
var redux_form_es = __webpack_require__(747);

// EXTERNAL MODULE: ./node_modules/reapop/lib/index.js
var lib = __webpack_require__(753);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./src/app/redux/types.js
var types = __webpack_require__(142);

// CONCATENATED MODULE: ./src/app/redux/reducers/reducerAuth.js
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



// import { getAuth } from 'Lib'

var reducerAuth_initialState = {
    user: null
};

/* harmony default export */ var reducerAuth = ({
    authen: function authen() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerAuth_initialState;
        var action = arguments[1];

        switch (action.type) {
            default:
                return _extends({}, state);
        }
    },
    backendInfo: function backendInfo() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var action = arguments[1];

        switch (action.type) {
            case types["CORE_GET_BACKEND_INFO_REQUEST"]:
                return {};
            case types["CORE_GET_BACKEND_INFO_SUCCESS"]:
                if (action.payload && !Array.isArray(action.payload) && _typeof(action.payload) === "object") {
                    var objPayload = action.payload;
                    if (!Array.isArray(objPayload.data) && _typeof(objPayload.data) === "object") {
                        return objPayload.data;
                    }
                    return {};
                } else {
                    return {};
                }
            case types["CORE_GET_BACKEND_INFO_FAILURE"]:
                return {};
            default:
                return {};
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/reducerCallAPI.js
var reducerCallAPI__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var initialStateCallAPI = {
    hasError: false,
    isLoading: false,
    errorMessage: '',
    errorCode: '',
    statusText: ''
},
    initialStateArray = [];

/* harmony default export */ var reducerCallAPI = ({
    errorList: function errorList() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialStateArray;
        var action = arguments[1];

        switch (action.type) {
            case types["n" /* SET_ERROR */]:
                var newError = [];
                if (action && Array.isArray(action.error)) {
                    newError = action.error;
                }
                return newError;
            case types["a" /* CORE_AUTH_VERIFY_FAILURE */]:
            case types["d" /* CORE_FIND_DISPLAY_INFO_FAILURE */]:
                if (action && !Array.isArray(action.payload) && reducerCallAPI__typeof(action.payload) === 'object') {
                    var _action$payload = action.payload,
                        errorList = _action$payload.errorList,
                        code = _action$payload.code,
                        message = _action$payload.message,
                        statusText = _action$payload.statusText,
                        statusCode = _action$payload.statusCode;
                    var url = action.url;

                    var _newError = [];
                    if (Array.isArray(errorList)) {
                        _newError = errorList.map(function (e) {
                            return e;
                        });
                    }

                    _newError.push({ code: code, message: message, isShow: false, statusText: statusText, statusCode: statusCode, url: url });

                    return _newError;
                }return state;
            case types["c" /* CORE_AUTH_VERIFY_SUCCESS */]:
            case types["f" /* CORE_FIND_DISPLAY_INFO_SUCCESS */]:
                if (action && !Array.isArray(action.payload) && reducerCallAPI__typeof(action.payload) === 'object') {
                    var _action$payload2 = action.payload,
                        errors = _action$payload2.errors,
                        result = _action$payload2.result;

                    if (!result && Array.isArray(errors)) {
                        var _errorList = [];
                        errors.forEach(function (e) {
                            var code = e.code,
                                message = e.message;

                            _errorList.push({ code: code, message: message, statusText: message, statusCode: code, isShow: false });
                        });
                        return _errorList;
                    }
                }
                return state;
            default:
                return state;
        }
    },
    reducerCallAPI: function reducerCallAPI() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialStateCallAPI;
        var action = arguments[1];

        switch (action.type) {

            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/core/ActionResourceArray.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ActionResourceArray = function () {
    function ActionResourceArray() {
        _classCallCheck(this, ActionResourceArray);

        this.status = "NO_ACTION";
        this.value = null;
        this.error = null;

        this.statusValue = {
            REQUEST: "REQUEST",
            REQUEST_SUCCESS: "REQUEST_SUCCESS",
            REQUEST_FAIL: "REQUEST_FAILURE",
            NO_ACTION: "NO_ACTION"
        };
    }

    _createClass(ActionResourceArray, [{
        key: "setStatus",
        value: function setStatus(status) {
            this.status = status;
        }
    }, {
        key: "setValue",
        value: function setValue(value) {
            this.value = value;
        }
    }, {
        key: "getDatas",
        value: function getDatas() {
            return this.value;
        }
    }, {
        key: "getDataById",
        value: function getDataById(id) {
            if (Array.isArray(this.value)) {
                return this.value.find(function (v) {
                    return v._id === id;
                });
            }

            return null;
        }
    }]);

    return ActionResourceArray;
}();

/* harmony default export */ var core_ActionResourceArray = (ActionResourceArray);
// CONCATENATED MODULE: ./src/app/core/ActionResourceObject.js
var ActionResourceObject__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ActionResourceObject__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ActionResourceObject = function () {
    function ActionResourceObject() {
        ActionResourceObject__classCallCheck(this, ActionResourceObject);

        this.status = "NO_ACTION";
        this.value = null;
        this.error = null;

        this.status = {
            REQUEST: "REQUEST",
            REQUEST_SUCCESS: "REQUEST_SUCCESS",
            REQUEST_FAIL: "REQUEST_FAILURE",
            NO_ACTION: "NO_ACTION"
        };
    }

    ActionResourceObject__createClass(ActionResourceObject, [{
        key: "setStatus",
        value: function setStatus(status) {
            this.status = status;
        }
    }, {
        key: "setValue",
        value: function setValue(value) {
            this.value = value;
        }
    }, {
        key: "getData",
        value: function getData() {
            return this.value;
        }
    }]);

    return ActionResourceObject;
}();

/* harmony default export */ var core_ActionResourceObject = (ActionResourceObject);
// EXTERNAL MODULE: ./src/app/model/displayModel.js + 1 modules
var displayModel = __webpack_require__(516);

// CONCATENATED MODULE: ./src/app/redux/reducers/reducerDisplay.js






/* harmony default export */ var reducerDisplay = ({
    allDisplay: function allDisplay(state, action) {
        if (!state) {
            state = new core_ActionResourceArray();
        }

        switch (action.type) {
            case types["k" /* CORE_LOAD_ALL_DISPLAY_REQUEST */]:
                state.setStatus(state.REQUEST);
                state.setValue(null);
                break;
            case types["l" /* CORE_LOAD_ALL_DISPLAY_SUCCESS */]:
                state.setStatus(state.REQUEST_SUCCESS);
                if (action.payload && action.payload.result == true) {
                    state.setValue(action.payload.datas);
                } else {
                    state.setValue([]);
                }

                break;
            case types["j" /* CORE_LOAD_ALL_DISPLAY_FAILURE */]:
                state.setStatus(state.REQUEST_FAILURE);
                state.setValue(action.payload);
                break;
            default:
                state.setStatus(state.NO_ACTION);
                // state.setValue(null)
                break;
        }

        return state;
    },
    display: function display(state, action) {
        if (!state) {
            state = new core_ActionResourceObject();
        }

        switch (action.type) {
            case types["e" /* CORE_FIND_DISPLAY_INFO_REQUEST */]:
                state.setStatus(state.REQUEST);
                state.setValue(null);
                break;
            case types["f" /* CORE_FIND_DISPLAY_INFO_SUCCESS */]:
                if (action.payload && action.payload.result == true) {
                    state.setStatus(state.REQUEST_SUCCESS);
                    state.setValue(action.payload.data);
                } else {
                    state.setStatus(state.REQUEST_FAILURE);
                    state.setValue(action.payload);
                }
                break;
            case types["d" /* CORE_FIND_DISPLAY_INFO_FAILURE */]:
                state.setStatus(state.REQUEST_FAILURE);
                state.setValue(action.payload);
                break;
            default:
                state.setStatus(state.NO_ACTION);
                // state.setValue(null)
                break;
        }

        return state;
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers.js








/* harmony default export */ var reducers = (Object(es["c" /* combineReducers */])({
    form: redux_form_es["a" /* reducer */],
    notifications: Object(lib["reducer"])(),
    authen: reducerAuth.authen,

    errorList: reducerCallAPI.errorList,

    allDisplay: reducerDisplay.allDisplay,
    display: reducerDisplay.display

}));
// CONCATENATED MODULE: ./src/store/configureStore.prod.js





/* harmony default export */ var configureStore_prod = __webpack_exports__["default"] = (function (initialState) {
    var middlewares = [src_middlewares["c" /* checkToken */], src_middlewares["d" /* setToken */], src_middlewares["b" /* api */], redux_thunk_es["a" /* default */]];

    var store = Object(es["d" /* createStore */])(reducers, initialState, es["a" /* applyMiddleware */].apply(undefined, middlewares));

    return store;
});

/***/ }),

/***/ 999:
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1000);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(1007)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js!./index.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js!./index.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ })

},[521]);


// WEBPACK FOOTER //
// app.57a61bdf83f57f2b55ef.js